import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import useFetch, { CacheTime } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { EquipmentResponse } from "./type.ts";

type useEquipmentParams = {
  startDate?: string | null;
  endDate?: string | null;
  bookingId?: string | null;
};

const useEquipment = (params: useEquipmentParams) => {
  const { startDate, endDate, bookingId } = params;

  const fetch = useFetch();

  const { data, isLoading, isError, error } = useQuery<
    EquipmentResponse | null,
    Error,
    EquipmentResponse
  >({
    queryKey: ["equipment", startDate, endDate],
    enabled: !!(startDate && endDate),
    queryFn: () =>
      fetch<EquipmentResponse>(`${Urls.Equipment}?startDate=${startDate}&endDate=${endDate}${bookingId ? `&bookingId=${bookingId}` : ''}`, {
        method: "GET",
      }),
    refetchInterval: 10000,
    gcTime: CacheTime,
    staleTime: CacheTime,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting equipment");
    }
  }, [error?.message, isError]);

  return {
    equipment: data?.equipments || [],
    isFetching: isLoading,
  };
};

export default useEquipment;
